"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.RenderTableData = exports.NonMemoRenderTableData = exports.RenderTable = exports.NonMemoRenderTable = void 0;

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray"),
    _slicedToArray3 = _interopRequireDefault(_slicedToArray2),
    _react = require("react"),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require("prop-types"),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _reactRedux = require("react-redux"),
    _reactReduxFirebase = require("react-redux-firebase"),
    _Spinner = require("office-ui-fabric-react/lib/Spinner"),
    _DivTable = require("../DivTable"),
    _get = require("lodash/get"),
    _get2 = _interopRequireDefault(_get),
    _formatting = require("../../formatting"),
    _officeUiFabricReact = require("office-ui-fabric-react");

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

function transformCell(a) {
  if ("boolean" == typeof a) return (0, _formatting.doFormatYesNo)(a);
  if (Array.isArray(a)) return a.join(", ");
  if ("string" == typeof a && a.startsWith("{")) try {
    var b = JSON.parse(a);
    if ("downloadURL" in b && "fileName" in b) return _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement("a", {
      target: "_blank",
      href: b.downloadURL
    }, _react2.default.createElement("div", null, "contentType" in b && b.contentType.startsWith("image/") && _react2.default.createElement("img", {
      target: "_blank",
      src: b.downloadURL,
      width: 200
    })), b.fileName));
  } catch (a) {}
  return a;
}

var RenderRow = _react2.default.memo(function (a) {
  var b = a.rowKey,
      c = a.rowSelector,
      d = a.rowDispatcher,
      e = a.colDefns,
      f = a.showKeyLabel,
      g = (0, _reactRedux.useSelector)(function (a) {
    return c(a, b);
  }),
      h = (0, _reactRedux.useDispatch)();
  if ((0, _react.useEffect)(function () {
    b && !!d && h(d(b));
  }, [b]), !(0, _reactReduxFirebase.isLoaded)(g) || g.isFetching) return _react2.default.createElement(_DivTable.TableRow, null, f && _react2.default.createElement(_DivTable.TableCell, null, b), _react2.default.createElement(_DivTable.TableCell, {
    colSpan: e.length
  }, !f && _react2.default.createElement("span", null, b), _react2.default.createElement(_Spinner.Spinner, {
    size: _Spinner.SpinnerSize.large
  })));
  if (g.errorMessage) return _react2.default.createElement(_DivTable.TableRow, {
    key: b
  }, f && _react2.default.createElement(_DivTable.TableCell, null, b), _react2.default.createElement(_DivTable.TableCell, {
    colSpan: e.length
  }, _react2.default.createElement("code", null, g.errorMessage)));
  var i = g.data;
  return _react2.default.createElement(_DivTable.TableRow, null, f && _react2.default.createElement(_DivTable.TableCell, null, b), e.map(function (a, b) {
    var c = (0, _slicedToArray3.default)(a, 2),
        d = c[1],
        e = "";
    return "string" == typeof d ? e = (0, _get2.default)(i, d, "") : "function" == typeof d ? e = d(i) : Array.isArray(d) && (e = d.map(function (a) {
      return (0, _get2.default)(i, a, "");
    }).join(" ")), _react2.default.createElement(_DivTable.TableCell, {
      key: "c" + b
    }, transformCell(e));
  }));
}),
    NonMemoRenderTable1 = function NonMemoRenderTable1(a) {
  var b = a.keyLabel,
      c = a.rowSelector,
      d = a.rowDispatcher,
      e = a.showHeader,
      f = a.showKeyLabel,
      g = !(f !== void 0) || f,
      h = a.colDefns,
      i = a.rowKeys;
  return _react2.default.createElement("div", null, _react2.default.createElement(_DivTable.Table, null, e !== void 0 && e && _react2.default.createElement(_react2.default.Fragment, null, g && _react2.default.createElement(_DivTable.TableHead, null, b), h.map(function (a, b) {
    var c = (0, _slicedToArray3.default)(a, 1),
        d = c[0];
    return _react2.default.createElement(_DivTable.TableHead, {
      key: "h" + b
    }, d);
  })), _react2.default.createElement(_react2.default.Fragment, null, i.map(function (a) {
    return _react2.default.createElement(RenderRow, {
      key: a,
      rowKey: a,
      rowSelector: c,
      rowDispatcher: d,
      colDefns: h,
      showKeyLabel: g
    });
  }))));
},
    RenderRowData = _react2.default.memo(function (a) {
  var b = a.rowData,
      c = a.colDefns,
      d = a.udButtons,
      e = a.passConfig,
      f = e === void 0 ? function () {} : e;
  return _react2.default.createElement(_DivTable.TableRow, null, c.map(function (a, c) {
    var d = (0, _slicedToArray3.default)(a, 2),
        e = d[1],
        g = "";
    return "string" == typeof e ? g = (0, _get2.default)(b, e, "") : "function" == typeof e ? g = e(b, f) : Array.isArray(e) && (g = e.map(function (a) {
      return (0, _get2.default)(b, a, "");
    }).join(" ")), _react2.default.createElement(_DivTable.TableCell, {
      key: "c" + c
    }, transformCell(g));
  }), !!d && _react2.default.createElement(_DivTable.TableCell, null, d(b)));
}),
    NonMemoRenderTableData1 = function NonMemoRenderTableData1(a) {
  var b = a.showHeader,
      c = a.colDefns,
      d = a.rowData,
      e = a.udButtons,
      f = a.passConfig;
  return _react2.default.createElement("div", null, _react2.default.createElement(_DivTable.Table, null, b !== void 0 && b && _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement(_DivTable.TableRow, null, c.map(function (a, b) {
    var c = (0, _slicedToArray3.default)(a, 1),
        d = c[0];
    return _react2.default.createElement(_DivTable.TableHead, {
      key: "h" + b
    }, d);
  }), !!e && _react2.default.createElement(_DivTable.TableHead, null))), _react2.default.createElement(_react2.default.Fragment, null, d.map(function (a, b) {
    return _react2.default.createElement(RenderRowData, {
      key: b,
      rowData: a,
      colDefns: c,
      udButtons: e,
      passConfig: f
    });
  }))));
};

NonMemoRenderTableData1.propTypes = {
  showHeader: _propTypes2.default.bool.isRequired,
  colDefns: _propTypes2.default.array.isRequired,
  rowData: _propTypes2.default.array.isRequired,
  udButtons: _propTypes2.default.func.isRequired,
  passConfig: _propTypes2.default.func.isRequired
}, NonMemoRenderTableData1.defaultProps = {
  showHeader: !1,
  udButtons: _officeUiFabricReact.nullRender,
  passConfig: function a() {}
};

var NonMemoRenderTable = exports.NonMemoRenderTable = NonMemoRenderTable1,
    RenderTable = exports.RenderTable = _react2.default.memo(NonMemoRenderTable1),
    NonMemoRenderTableData = exports.NonMemoRenderTableData = NonMemoRenderTableData1,
    RenderTableData = exports.RenderTableData = _react2.default.memo(NonMemoRenderTableData1);